import { useCallback, useRef } from 'react';

export const useListHeight = () => {
  const listHeightRef = useRef<Record<string, number>>({});

  const setListHeight: SetListHeight = useCallback(({ height, title }) => {
    if (!listHeightRef.current) {
      return;
    }
    listHeightRef.current[title] = height;
  }, []);

  return {
    listHeight: listHeightRef.current,
    setListHeight,
  };
};

export type SetListHeight = ({
  height,
  index,
  title,
}: {
  height: number;
  index: number;
  title: string;
}) => void;
